document.addEventListener('DOMContentLoaded', function () {
  const sections = document.querySelectorAll('[data-recipe-list-section]');
  if (!sections.length) return;

  sections.forEach((section) => {
    const initialCount = parseInt(section.dataset.initialCount, 10) || 12;
    const loadMoreCount = parseInt(section.dataset.loadMoreCount, 10) || 12;

    const categoryButtons = section.querySelectorAll('.category-button');
    const recipeLists = section.querySelectorAll('.recipeList');
    const loadMoreButtons = section.querySelectorAll('.load-more-button');

    // リストを日付順（降順）に並べ替える関数
    const sortRecipesByDate = (list) => {
      const items = Array.from(list.querySelectorAll('.recipeDetails'));
      items.sort((a, b) => {
        const dateA = new Date(a.dataset.postedOn);
        const dateB = new Date(b.dataset.postedOn);
        return dateB - dateA; // 降順
      });
      items.forEach(item => list.appendChild(item)); // 並べ替えた順にDOMを再配置
    };

    const initialCategory = 'All';
    const initialList = section.querySelector(`.category-${initialCategory}`);
    const initialButton = section.querySelector(`.category-button[data-category="${initialCategory}"]`);
    if (!initialList || !initialButton) return;

    // 各リストを日付順に並べ替え
    recipeLists.forEach(sortRecipesByDate);

    // 初期状態で「すべて」のリストを表示（設定件数まで）
    recipeLists.forEach(list => {
      if (list === initialList) {
        list.style.display = 'grid';
        const allItems = list.querySelectorAll('.recipeDetails');
        allItems.forEach((item, index) => {
          item.style.display = index < initialCount ? 'block' : 'none';
        });
      } else {
        list.style.display = 'none';
      }
    });

    // 初期状態で「すべてを見る」ボタンを適切に表示
    loadMoreButtons.forEach(button => {
      if (button.dataset.category === initialCategory) {
        const hiddenItems = initialList.querySelectorAll('.recipeDetails[style*="display: none;"]');
        button.style.display = hiddenItems.length > 0 ? 'block' : 'none';
      } else {
        button.style.display = 'none';
      }
    });

    initialButton.classList.add('active');

    // カテゴリー切り替え
    categoryButtons.forEach(button => {
      button.addEventListener('click', () => {
        const selectedCategory = button.dataset.category;
        const selectedList = section.querySelector(`.category-${selectedCategory}`);
        if (!selectedList) return;

        recipeLists.forEach(list => {
          if (list === selectedList) {
            list.style.display = 'grid';
            const allItems = list.querySelectorAll('.recipeDetails');
            allItems.forEach((item, index) => {
              item.style.display = index < initialCount ? 'block' : 'none';
            });
          } else {
            list.style.display = 'none';
          }
        });

        loadMoreButtons.forEach((btn) => {
          if (btn.dataset.category === selectedCategory) {
            const list = section.querySelector(`.category-${selectedCategory}`);
            const hiddenItems = list.querySelectorAll('.recipeDetails[style*="display: none;"]');
            btn.style.display = hiddenItems.length > 0 ? 'block' : 'none';
          } else {
            btn.style.display = 'none';
          }
        });

        categoryButtons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');
      });
    });

    // 「すべてを見る」ボタンのクリック処理
    loadMoreButtons.forEach(button => {
      button.addEventListener('click', () => {
        const category = button.dataset.category;
        const list = section.querySelector(`.category-${category}`);
        if (!list) return;
        const hiddenItems = list.querySelectorAll('.recipeDetails[style*="display: none;"]');

        for (let i = 0; i < loadMoreCount; i++) {
          if (hiddenItems[i]) {
            hiddenItems[i].style.display = 'block';
          }
        }

        const remainingHiddenItems = list.querySelectorAll('.recipeDetails[style*="display: none;"]');
        if (remainingHiddenItems.length === 0) {
          button.style.display = 'none';
        }
      });
    });
  });
});
